"use client"

import { Suspense } from "react"
import JobDisplay from "./JobDisplay"

type Props = {
  data?: any
  jobResponse?: any
}

/**
 * Wrapper component for JobDisplay that provides a Suspense boundary.
 * Required because JobDisplay uses useSearchParams() which needs Suspense.
 */
export default function JobDisplayWrapper({ data, jobResponse }: Props) {
  return (
    <Suspense>
      <JobDisplay jobResponse={jobResponse} />
    </Suspense>
  )
}
